import $ from "jquery";
import { gsap } from "gsap";
import imagesLoaded from "imagesloaded";

// import "lazysizes";
// import "lazysizes/plugins/parent-fit/ls.parent-fit.js";
export const winW =
    document.documentElement.clientWidth || window.innerWidth;
export const winH =
    document.documentElement.clientHeight || window.innerHeight;

const font_family = function () {
    $('head').append('<link rel="preconnect" href="https://fonts.googleapis.com">')
    $('head').append('<link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>')
    $('head').append('<link href="https://fonts.googleapis.com/css2?family=Noto+Serif+TC&display=swap" rel="stylesheet">')
    // $('head').append('<link href="assets/fonts/MaruFoPro-Medium.otf" rel="stylesheet">')
}

export const init_imageloaded = function (callback, timeoutMs = 1000) {
    const run = () => {

        gsap.to(".loading", { duration: .8, delay: .3, opacity: 0, display: "none", ease: "power1.out" });
        font_family();//加載字體

        $('a[href$="#"]').click(function (e) {
            e.preventDefault();
        });

        if (typeof callback === "function") {
            callback();
        }
    };

    const images = document.querySelectorAll(".lazyload");
    if (images.length === 0) {
        run();
        return;
    }

    let done = false;
    const finish = () => {

        if (done) return;
        done = true;
        run();
    };

    imagesLoaded(images, finish);

    // 逾時 fallback：避免因單一圖片載入失敗或漏事件而永不觸發
    setTimeout(finish, timeoutMs);
}

const getCurrentPageFilename = () => {
    const filename = (window.location.pathname.split("/").pop() || "").toLowerCase();
    // 若網址沒有檔名（例如 / 或 /dist/），視為 index.html
    return filename.includes(".html") ? filename : "index.html";
};

export const navActiveMixin = {
    data() {
        return {
            currentPage: "",
        };
    },
    mounted() {
        this.currentPage = getCurrentPageFilename();
    },
    methods: {
        isNavActive(targetHref) {
            const target = (targetHref || "").toLowerCase();
            if (!target) return false;

            const current = (this.currentPage || "").toLowerCase();
            const normalizedCurrent = current.includes(".html") ? current : "index.html";
            return normalizedCurrent === target;
        },
    },
};

export const searchMixin = {
    data() {
        return {
            searchOpen: false,
            escHandler: null,
        };
    },
    methods: {
        openSearch() {
            this.searchOpen = true;
            this.$nextTick(() => {
                if (this.$refs.searchInput) {
                    this.$refs.searchInput.focus();
                }
            });
        },
        closeSearch() {
            this.searchOpen = false;
        },
        bindEscClose() {
            this.escHandler = (e) => {
                if (e.key === "Escape" && this.searchOpen) {
                    this.closeSearch();
                }
            };
            window.addEventListener("keydown", this.escHandler);
        },
        unbindEscClose() {
            if (this.escHandler) {
                window.removeEventListener("keydown", this.escHandler);
            }
        },
    },
};

export const menuMixin = {
    data() {
        return {
            menuOpen: false,
        };
    },
    methods: {
        toggleMenu() {
            if (this.menuOpen) {
                this.closeMenu();
            } else {
                this.menuOpen = true;
            }
        },
        closeMenu() {
            this.menuOpen = false;
            $(".nav .submenu_list").stop(true, true).slideUp(0).attr("data-open", "false");
            $(".nav .nav_li").removeClass("is_active");
        },
        onNavClick(e) {
            if (!this.menuOpen) return;
            e.preventDefault();
            const $li = $(e.currentTarget).closest(".nav_li");
            const $submenu = $li.children(".submenu_list");
            if (!$submenu.length) return;

            const isOpen = $submenu.attr("data-open") === "true";
            if (isOpen) {
                $submenu.stop(true, false).slideUp(280);
                $submenu.attr("data-open", "false");
                $li.removeClass("is_active");
            } else {
                $submenu.stop(true, false).slideDown(280);
                $submenu.attr("data-open", "true");
                $li.addClass("is_active");
            }
        },
    },
};